import camelcaseKeys from 'camelcase-keys'
import { PageObjectRelatedPage } from '@/entities/webapp-pages/page-objects/RelatedPage'

export class PageNavigation {
  constructor (params = {}) {
    const { navigation, relatedPages } = camelcaseKeys(params ? params : {}, { deep: true })
    const { title, featured } = camelcaseKeys(navigation || {}, { deep: true })
    this.title = title || []
    this.featured = featured || false
    this.relatedPages = relatedPages ? relatedPages.map((page) => {
      return new PageObjectRelatedPage(page)
    })
      .filter((item) => {
        if (item.page) {
          return item.page.active
        }
      })
      .sort((a, b) => {
        if (a.order < b.order) {
          return -1
        } else if (a.order > b.order) {
          return 1
        }
        return 0
      }) : []
  }
}
